import { getSavedState, removeState, saveState } from '@state/helpers'
import { getMyOnboardingSteps } from '@src/api/onboarding'
import { getHasActiveBrokerActivity } from '@utils/onboarding-helpers'

const SHOULD_SHOW_WELCOME_OVERLAY_KEY = 'onboarding.shouldShowWelcomeOverlay'
const HAS_PENDING_ONBOARDING_KEY = 'onboarding.hasPendingOnboarding'

export const state = {
  allSteps: [],
  hasPendingOnboarding: getSavedState(HAS_PENDING_ONBOARDING_KEY, false),
  shouldShowWelcomeOverlay: getSavedState(SHOULD_SHOW_WELCOME_OVERLAY_KEY, false),
}

export const getters = {
  allSteps(state) {
    return state.allSteps
  },
  hasPendingOnboarding(state, getters, rootState, rootGetters) {
    return rootGetters['user/canAccessOnboarding'] && state.hasPendingOnboarding
  },
  shouldShowWelcomeOverlay(state) {
    return state.shouldShowWelcomeOverlay
  },
}

export const mutations = {
  SET_ALL_STEPS(state, steps) {
    state.allSteps = steps
  },
  SET_HAS_PENDING_ONBOARDING(state, value) {
    const hasPendingOnboarding = Boolean(value)
    state.hasPendingOnboarding = hasPendingOnboarding
    saveState(HAS_PENDING_ONBOARDING_KEY, hasPendingOnboarding)
  },
  SET_SHOULD_SHOW_WELCOME_OVERLAY(state, value) {
    state.shouldShowWelcomeOverlay = value
    if (value) {
      saveState(SHOULD_SHOW_WELCOME_OVERLAY_KEY, true)
      return
    }

    removeState(SHOULD_SHOW_WELCOME_OVERLAY_KEY)
  },
}

export const actions = {
  async refreshPendingOnboarding({ commit, rootGetters }) {
    if (!rootGetters['user/canAccessOnboarding']) {
      commit('SET_HAS_PENDING_ONBOARDING', false)
      return false
    }

    const { data } = await getMyOnboardingSteps()
    const hasPendingOnboarding = getHasActiveBrokerActivity(data)
    commit('SET_HAS_PENDING_ONBOARDING', hasPendingOnboarding)

    return hasPendingOnboarding
  },
}
